//
// ColumnBase.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "../../BIRDModel";
import "@sas-dvr/ltjs-commons/models/data/dataset/DataUsage";

var ColumnBase = createModule("BIRD::ColumnBase", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        xref: 7,
        usage: 4,
        format: 7,
        label: 7,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default ColumnBase;
